import { render, staticRenderFns } from "./GoodsButtonPrice.vue?vue&type=template&id=4fee5030&scoped=true"
import script from "./GoodsButtonPrice.vue?vue&type=script&lang=js"
export * from "./GoodsButtonPrice.vue?vue&type=script&lang=js"
import style0 from "./GoodsButtonPrice.vue?vue&type=style&index=0&id=4fee5030&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fee5030",
  null
  
)

export default component.exports